// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"31231":"ca2500eb2f369101ac5b","34642":"3b5260cc29c08b76cf45","34764":"f8a5416441841686d86b","42600":"71788adf54a938a4dad5","43930":"4090887c17d4c5b50c18","44341":"7b0bcb11b62bfc6ca91f","60868":"a8b59fe21a607b77e863","87876":"60fb663531385f6c06c9"}[chunkId] + ".min.js";
};